import type { TranslationMessages } from '../types';

export const project_management: TranslationMessages = {
  kanban_board: 'Kanban Board',
  gantt_chart: 'Gantt Chart',
  kanban_subtitle: 'Manage tasks and track progress',
  gantt_subtitle: 'Visualize project timeline and dependencies',
  kanban_implementation: 'Kanban Board - Implementation in progress',
  kanban_soon: 'Drag-and-drop functionality will be available soon',
  gantt_implementation: 'Gantt Chart - Implementation in progress',
  gantt_soon: 'Timeline visualization will be available soon',
  create_task: 'Create Task',
  edit_task: 'Edit Task',
  delete_task: 'Delete Task',
  task_details: 'Task Details',
  status: {
    todo: 'To Do',
    in_progress: 'In Progress',
    review: 'Review',
    done: 'Done',
    blocked: 'Blocked',
  },
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
  },
  fields: {
    title: 'Title',
    description: 'Description',
    status: 'Status',
    priority: 'Priority',
    assignee: 'Assignee',
    due_date: 'Due Date',
    start_date: 'Start Date',
    estimated_hours: 'Estimated Hours',
    actual_hours: 'Actual Hours',
    tags: 'Tags',
    dependencies: 'Dependencies',
  },
  messages: {
    task_created: 'Task created successfully',
    task_updated: 'Task updated successfully',
    task_deleted: 'Task deleted successfully',
    confirm_delete: 'Are you sure you want to delete this task?',
    load_error: 'Failed to load data',
  },
  ai_autofill: 'AI Autofill',
  ai_refine: 'AI Refine',
  ai_enhance_tooltip: 'AI Enhance: Autofill fields from title, or refine existing data',
  ai_autofill_tooltip: 'AI Autofill: Automatically fill all task fields',
  ai_refine_tooltip: 'Refine task fields with AI based on your instructions',
  ai_autofill_success: 'Task fields have been enhanced with AI',
  ai_autofill_error: 'Failed to enhance task fields. Please try again.',
  ai_refine_success: 'Task fields have been refined based on your instructions',
  ai_refine_error: 'Failed to refine task fields. Please try again.',
  ai_refine_dialog_title: 'AI Refine Task',
  ai_refine_prompt_label: 'Instructions for AI refinement',
  ai_refine_prompt_placeholder: 'e.g., "Make the description more detailed", "Set priority to high", "Add tags for frontend development"',
  ai_refine_prompt_hint: 'Provide specific instructions on how you want the task fields to be refined or improved.',
  ai_refine_prompt_required: 'Please provide instructions for refinement',
  delete_confirm_title: 'Delete Task',
  delete_confirm_desc: 'Are you sure you want to delete this task? This action cannot be undone.',
  select_assignee: 'Select assignee...',
  add_tag_placeholder: 'Press Enter to add tag',
  };
